import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';
import SendMailToList from './modules/SendEmailToList/index';
import SendToSponsorsAndPrepare from './modules/SendToSponsorsAndPrepare';
import ResendToSponsor from './modules/ResendToSponsor';
import UploadData from './modules/UploadData';
import UpdateData from './modules/UpdateData';


interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}

interface IParams {
  projectHash: string;
  eventHash: string;
}

const Invitation: React.FC = () => {
  const endpoint = '/invitation';
  const title = 'Convite';

  const { projectHash, eventHash } = useParams<IParams>(); const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID' },
    project_id: {
      ref: 'project_id',
      column: 'project_id',
      label: 'Projeto',

    },
    hash: {
      ref: 'hash',
      column: 'hash',
      label: 'Hash',

    },
    title: {
      ref: 'title',
      column: 'title',
      label: 'Título',

    },
    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {


    title: {
      model: 'input',
      type: 'text',
      name: 'title',
      label: 'Título do convite',
    },
    owner: {
      model: 'input',
      type: 'text',
      name: 'owner',
      label: 'Máscara',
    },
    reply_to: {
      model: 'input',
      type: 'text',
      name: 'reply_to',
      label: 'E-mail de resposta',
    },

    description: { model: 'richText', type: 'text', name: 'description', label: 'Descritivo 1' },
    description2: { model: 'richText', type: 'text', name: 'description2', label: 'Descritivo 2' },
    header_image: {
      model: 'imageSingle', list: [
        { label: 'Imagem', name: 'url', type: 'input' },

      ], type: 'text', name: 'header_image', label: 'Imagem de cabeçalho'
    },
    footer_image: {
      model: 'imageSingle', list: [
        { label: 'Imagem', name: 'url', type: 'input' },

      ], type: 'text', name: 'footer_image', label: 'Imagem de rodapé'
    },


    response_copy: {
      model: 'input',
      type: 'text',
      name: 'response_copy',
      label: 'Copiar confirmação',
    },
    response_title: {
      model: 'input',
      type: 'text',
      name: 'response_title',
      label: 'Título da confirmação',
    },
    response_description: { model: 'richText', type: 'text', name: 'response_description', label: 'Descritivo da confirmação' },

    response_header_image: {
      model: 'imageSingle', list: [
        { label: 'Imagem', name: 'url', type: 'input' },

      ], type: 'text', name: 'response_header_image', label: 'Imagem de cabeçalho da confirmação'
    },
    response_footer_image: {
      model: 'imageSingle', list: [
        { label: 'Imagem', name: 'url', type: 'input' },

      ], type: 'text', name: 'response_footer_image', label: 'Imagem de rodapé da confirmação'
    },

  };

  const formSchemaUpdate = {
    ...formSchema
  };

  const formValidation: Record<string, ValidationSchema> = {

  };


  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
      (lineData: Record<string, any>) => SendMailToList({ lineData }),
      (lineData: Record<string, any>) => SendToSponsorsAndPrepare({ lineData }),
      (lineData: Record<string, any>) => ResendToSponsor({ lineData }),
      (lineData: Record<string, any>) => UploadData({ lineData }),
      (lineData: Record<string, any>) => UpdateData({ lineData }),
    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default Invitation;
